import { useDispatch } from "react-redux";
import { deleteProduct } from "../store/action"

import ProductEdit from "./ProductEdit";

function MainTableRow({item, index}) {
    const dispatch = useDispatch()

    const handleDelete = (e) => {
        e.preventDefault()
        dispatch(deleteProduct(e.target.value))
      }

    return (
        <tr key={item.id}>
            <th scope="row">{index + 1}</th>
            <td>{item.name}</td>
            <td>{item.Category.name}</td>
            <td>{item.price}</td>
            <td>{item.User.username}</td>
            <td>
                <img className="rounded-circle w-25" src={item.mainImg} />
            </td>
            <td>

                <button className="btn btn-success" data-toggle="modal" data-target={"#imagesModal" + item.id}>Show Images</button>

                <div className="modal fade" id={"imagesModal" + item.id} tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div id="carouselExampleControls" className="carousel slide" data-ride="carousel">
                                    <div className="carousel-inner">
                                        <div className="">
                                            <img className="d-block w-100" src={item.mainImg} alt="First slide" />
                                        </div>
                                        {item.Images.map(e => {
                                            return (
                                                <div key={e.id}>
                                                    <div className="">
                                                        <img className="d-block w-100" src={e.imgUrl} />
                                                    </div>
                                                </div>
                                            )
                                        })}

                                        <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                            <span className="sr-only">Previous</span>
                                        </a>
                                        <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                            <span className="sr-only">Next</span>
                                        </a>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </td>
            <td>

                <ProductEdit item={item} />

                <button className="btn btn-danger" value={item.id} onClick={handleDelete}>Delete</button>
            </td>
        </tr>
    )
}

export default MainTableRow